import React from 'react';
import styled from '@emotion/styled';
import { CreditCard as CreditCardModel } from '~/types/models';
import cx from 'classnames';
import { Button } from '@vimily/bonjoro-ui-components/Button';
import { RequireEmailVerification } from '~/App/Components/RequireEmailVerification';

const Wrapper = styled.div`
  display: flex;
  padding: 20px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  width: 100%;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Icon = styled.i`
  font-size: 3em;
`;

const InfoBlock = styled.div`
  margin-left: 30px;

  @media (max-width: 480px) {
    margin-left: 0;
    text-align: center;
  }
`;

const InfoLabel = styled.label`
  font-size: 12px;
  font-weight: normal;
  margin-bottom: 0;
  color: #b4b4b4;
`;

const InfoValue = styled.p`
  color: #666666;
  margin-bottom: 0;
`;

interface CreditCardProps extends Pick<CreditCardModel, 'brand' | 'last4'> {
  id: string;
  expiryMonth: number;
  expiryYear: number;
  className?: string;
  onChangeCardClick?: (id: string) => void;
}

const CreditCard = ({
  id,
  expiryMonth,
  expiryYear,
  last4,
  className,
  brand,
  onChangeCardClick,
}: CreditCardProps) => {
  return (
    <Wrapper className={className}>
      <Icon className={cx(['fab', { [`fa-cc-${brand}`]: true }])} />
      <InfoBlock>
        <InfoLabel>Card number</InfoLabel>
        <InfoValue>XXXX XXXX XXXX {last4}</InfoValue>
      </InfoBlock>
      <InfoBlock>
        <InfoLabel>Expiry date</InfoLabel>
        <InfoValue>
          {expiryMonth}/{expiryYear}
        </InfoValue>
      </InfoBlock>
      {onChangeCardClick && (
        <div className='flex grow justify-end'>
          <RequireEmailVerification>
            {(isEmailVerified) => (
              <Button
                onClick={() => onChangeCardClick?.(id)}
                variant='secondary'
                disabled={!isEmailVerified}
              >
                Change card
              </Button>
            )}
          </RequireEmailVerification>
        </div>
      )}
    </Wrapper>
  );
};

export default CreditCard;
